import { SELECTED_DISTRIBUTOR } from "./type"
const retailerId= sessionStorage.getItem('rid')
const initialState = {
    id: null,
    requesterId:null,
    isSuperAdmin:null
}
const selectedDistributorReducer = (state = initialState, action) => {
    switch (action.type) {
        case SELECTED_DISTRIBUTOR:
            return {
                ...state,
                ...action.payload
            }
       

        default:
            return state
    }
}

export default selectedDistributorReducer